<div class="offer-delay-container">

  <div class="header">
    <div>{{title}} </div>
    <fi-button
      variant="tertiary"
      tone="neutral"
      size="lg"
      [iconOnly]="true"
      (click)="closeDialog()"
    >
      <mat-icon fiButtonIcon>close</mat-icon>
      <span fiTranslation="ALT_TEXT_DIALOG_CLOSE"></span>
    </fi-button>
  </div>

  <div class="main-container">
    <div class="horizontal-container">
      <fi-request-contacts [contactToDisplay]="contactToDisplay" [companyContacts]="companyContacts"></fi-request-contacts>
      <div class="form has-date-dropdown">
        <div class="form-title" fiTranslation="REQUEST_DETAIL_APPOINTMENT_HEADLINE_APPOINTMENT_DETAILS"></div>

        <div class="row">
          <fi-input
            type="SELECT"
            labelKey="ACTION_GENERAL_HEADLINE_PERIOD"
            [translateOptions]="true"
            namePropertyPath="Translation"
            [options]="dateOptionTypes"
            [selectedOptionsOrValues]="selectedTypeId"
            (onChange)="setPeriods(+$event)"
            >

          </fi-input>
        </div>

        <div class="row">
          <fi-input
            labelKey="ACTION_GENERAL_HEADLINE_DATE"
            type="DAY"
            [selectedOptionsOrValues]="selectedDate"
            (onDateTimeChange)="onDateSelect($event)"
            >
          </fi-input>

          <fi-input
            labelKey="REQUEST_DETAIL_APPOINTMENT_TIME"
            type="TIME"
            [selectedOptionsOrValues]="selectedDate"
            (onDateTimeChange)="onDateSelect($event, true)"
            >
          </fi-input>
        </div>

        @if (appointmentExists) {
          <div class="error-message" fiTranslation="ACTION_APPOINTMENT_OVERLAP"></div>
        }

        <div>
          <div class="field-title" fiTranslation="ACTION_GENERAL_HEADLINE_REQUEST_NOTE2"></div>
          <fi-editor
            [noUploads]="true"
            [placeholderTranslation]="'REQUEST_DETAIL_NOTE_PLACEHOLDER'"
            (isLongDescription)="inValidNote = $event"
            (textChanged)="note = $event">
          </fi-editor>
        </div>
      </div>
    </div>

  </div>


  <div class="footer">
    <button (click)="submit()" [disabled]="!formIsValid">
      <img [src]="iconUrl" alt="Action icon">
      <span> {{title}} </span>
    </button>
  </div>

</div>
